import { createEvmChainList } from '../utils/evmChain'

export const blankApiKeyEvmChainList = createEvmChainList({
  etherscanApiKey: '',
  fantomApiKey: '',
  roninApiKey: '',
})
